import { showroomMenu } from './showroom-menu';
import { vendorMenu } from './vendor-menu';
import { superadminMenu } from './superadmin-menu';

export const appMenu = {
  showroomMenu,
  vendorMenu,
  superadminMenu
}
